import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import $ from "jquery";

import ComponentModal, { ModalSize } from "./ComponentModal";
import PropTypes from "prop-types";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "CREATE_APPLICATION_MODAL_WIZARD";
const ModalId = "CreateApplicationModalWizardId"

const CreateApplicationModalWizard = (props) => {
    const intl = useIntl();

    const [modal, setModal] = useState(null);

    $(document).ready(function () {
        $("#" + ModalId).on('shown.bs.modal', function() {
            $('input[name="applicationName"]').focus();
        });
    });

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect getComponent");
        if (props.getComponent) {
            setModal(
                <ComponentModal
                    id={ModalId}
                    title={props.title}
                    icon={props.icon}
                    showModalOnInit={true}
                    showFirstButton={true}
                    firstButtonLabel={intl.messages.create}
                    disableFirstButton={props.disableFirstButton}
                    onClick={handleAction}
                    onClose={props.onClose}
                    disableDismiss={true}
                    size={ModalSize.Big}
                    iconColor={props.iconColor}
                >
                    {props.getComponent(true)}
                </ComponentModal>
            )
        }
    }, [props.getComponent]);

    const handleAction = (event) => {
        LogService.debug(LOG_TAG, "handleAction");
        if (props.action) {
            props.action()
                .then((object) => {
                    handleOnSuccess(object?.title, object?.component, object?.action, object?.applicationId);
                })
                .catch((object) => {
                    handleOnFailed(object?.title, object?.errorMessage);
                });
        }
    }

    const handleOnSuccess = (title, successComponent, editAction, appId) => {
        LogService.debug(LOG_TAG, "handleOnSuccess");
        setModal(
            <ComponentModal
                id={ModalId}
                title={title}
                icon={props.icon}
                showModalOnInit={true}
                showFirstButton={true}
                firstButtonLabel={intl.messages.edit}
                onClick={() => {
                    setModal(null);
                    editAction(appId);
                }}
                onClose={props.onClose}
                size={ModalSize.Big}
                iconColor={props.iconColor}
            >
                {successComponent}
            </ComponentModal>
        );
    }

    const handleOnFailed = (title, errorMessage) => {
        LogService.debug(LOG_TAG, "handleOnFailed");
        setModal(
            <ComponentModal
                id={ModalId}
                title={title}
                icon={props.icon}
                showModalOnInit={true}
                showFirstButton={true}
                firstButtonLabel={intl.messages.create}
                onClick={handleAction}
                onClose={props.onClose}
                disableDismiss={true}
                errorMessage={errorMessage}
                size={ModalSize.Big}
                iconColor="warning"
            >
                {props.getComponent(true)}
            </ComponentModal>
        );
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div>
            {modal}
        </div>
    );
}

CreateApplicationModalWizard.defaultProps = {
    title: "",
    icon: null,
    getComponent: null,
    action: null,
    onClose: null,
    disableFirstButton: false,
    iconColor: ""
}

CreateApplicationModalWizard.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    getComponent: PropTypes.func,
    action: PropTypes.func,
    onClose: PropTypes.func,
    disableFirstButton: PropTypes.bool,
    iconColor: PropTypes.string
};

export default CreateApplicationModalWizard;